import { createReducer, on } from '@ngrx/store';
import {
  showActionModal,
  hideActionModal,
  showInfoModal,
  hideInfoModal,
  showToast,
  hideToast,
  openSidebar,
  closeSidebar,
  toggleSidebar,
  ToastTone,
} from './modal.actions';

interface ActionModalState {
  isOpen: boolean;
  title: string;
  message: string;
  messageParams: Record<string, string> | null;
  actionState: string;
  onConfirm: (() => void) | null;
  onCancel: (() => void) | null;
  successToastMessage: string | null;
  deferToast: boolean;
}

interface InfoModalState {
  isOpen: boolean;
  title: string;
  message: string;
  messageParams: Record<string, string> | null;
}

export interface ModalState {
  actionModal: ActionModalState;
  infoModal: InfoModalState;
  toast: {
    isOpen: boolean;
    message: string;
    tone: ToastTone;
  };
  sidebar: {
    isOpen: boolean;
  };
}

export const initialModalState: ModalState = {
  actionModal: {
    isOpen: false,
    title: '',
    message: '',
    messageParams: null,
    actionState: '',
    onConfirm: null,
    onCancel: null,
    successToastMessage: null,
    deferToast: false,
  },
  infoModal: {
    isOpen: false,
    title: '',
    message: '',
    messageParams: null,
  },
  toast: {
    isOpen: false,
    message: '',
    tone: 'success',
  },
  sidebar: {
    isOpen: false,
  },
};

export const modalReducer = createReducer(
  initialModalState,
  on(showActionModal, (state, { title, message, messageParams, actionState, onConfirm, onCancel, successToastMessage, deferToast }) => ({
    ...state,
    actionModal: {
      isOpen: true,
      title,
      message,
      messageParams: messageParams ?? null,
      actionState,
      onConfirm,
      onCancel: onCancel ?? null,
      successToastMessage: successToastMessage ?? null,
      deferToast: deferToast ?? false,
    },
  })),
  on(hideActionModal, (state) => ({
    ...state,
    actionModal: {
      ...initialModalState.actionModal,
    },
  })),
  on(showInfoModal, (state, { title, message, messageParams }) => ({
    ...state,
    infoModal: { isOpen: true, title, message, messageParams: messageParams ?? null },
  })),
  on(hideInfoModal, (state) => ({
    ...state,
    infoModal: { ...state.infoModal, isOpen: false },
  })),
  on(showToast, (state, { message, tone }) => ({
    ...state,
    toast: {
      isOpen: true,
      message,
      tone: tone ?? 'success',
    },
  })),
  on(hideToast, (state) => ({
    ...state,
    toast: {
      ...state.toast,
      isOpen: false,
    },
  })),
  on(openSidebar, (state) => ({
    ...state,
    sidebar: {
      isOpen: true,
    },
  })),
  on(closeSidebar, (state) => ({
    ...state,
    sidebar: {
      isOpen: false,
    },
  })),
  on(toggleSidebar, (state) => ({
    ...state,
    sidebar: {
      isOpen: !state.sidebar.isOpen,
    },
  })),
);
